/**
 * @generated SignedSource<<faa15a5ce4f8a1e457f9d78ab526888c>>
 * @relayHash 82736b6ac47b78477e2aaa327f346bda
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bcb2e7997707bd4a85f3e6a076e96c5a6e2458649a0f7c89f5c62eb580a0ef40

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { RisksTabIssueQuery } from './RisksTabIssueQuery.graphql';

const node: PreloadableConcreteRequest<RisksTabIssueQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bcb2e7997707bd4a85f3e6a076e96c5a6e2458649a0f7c89f5c62eb580a0ef40",
    "metadata": {},
    "name": "RisksTabIssueQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
